import { useQuery } from '@tanstack/react-query';
import { tedSearchService } from '../services/ted-search.service';
import { TedSearchParams } from '../types/opportunity.types';

export const TED_SEARCH_KEY = 'ted-search';

/**
 * Hook pour la recherche TED (Europe)
 */
export function useTedSearch(params: TedSearchParams, enabled = true) {
  return useQuery({
    queryKey: [TED_SEARCH_KEY, params],
    queryFn: () => tedSearchService.search(params),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
